// Communication-related types

import { WorkList } from "./work.types";

// Customer communication
export interface CustomerCommunication {
  CommunicationNo: number;
  Type?: CommunicationTypeEnum;
  Value?: string;
  Description?: string;
  IsPrimary?: boolean;
  Invoice?: boolean;
  Sms?: boolean;
  SetByCustomer?: boolean;
  Status?: boolean;
  IsNoExternal?: boolean;
  ContactPersonNo?: number;
  ContactPerson?: ContactPersons;
}

// Contact person
export interface ContactPersons {
  ContactPersonId: number | null;
  Firstname: string;
  Lastname: string;
  Phone: string;
  Email: string;
  IsResponsible: boolean;
  Comment: string;
  Roles: ContactPersonRolesEnum[];
  Communications: CustomerCommunication[];
}

// New company communication
export interface NewCompanyCommunication {
  ContactPersonId: number | null;
  Firstname: string;
  Lastname: string;
  IsResponsible: boolean;
  Phone: string;
  Email: string;
  Roles: ContactPersonRolesEnum[];
  Communications: CustomerCommunication[];
}

// Delete request
export interface DeleteCustomerCommunication {
  customerId: number;
  contactPersonId: number;
}

// Communication type enum
export enum CommunicationTypeEnum {
  Telefon = 1,
  Mobiltelefon = 2,
  Epost = 3,
  Facebook = 4,
  Twitter = 5,
  Brev = 6,
  EndastPdf = 7,
  CompanyContact = 8,
}

// Contact person roles enum
export enum ContactPersonRolesEnum {
  CEO = 1,
  PurchaseManager = 2,
  HeadFinance = 3,
  Finance = 4,
  Owner = 5,
  Facility = 6,
  Marketing = 7,
  Chairman = 8,
  Environment = 9,
}

// Email-related types
export interface EmailData {
  Conversations: Conversation[];
  OpenWorks: WorkList[];
}

export interface Conversation {
  Id: string;
  ConversationId: string;
  WorkId: number;
  EventDataId: number;
}

export interface IMessage {
  Id: string;
  ConversationId: string;
  CreatedDateTime: string;
  LastModifiedDateTime: string;
  ChangeKey: string;
  ReceivedDateTime: string;
  SentDateTime: string;
  HasAttachments: boolean;
  Subject: string;
  BodyPreview: string;
  IsRead: boolean;
  From: Recipient;
  ToRecipients: Recipient[];
  Body: EmailBody;
}

export interface Recipient {
  EmailAddress: EmailAddress;
}

export interface EmailAddress {
  Name: string;
  Address: string;
}

export interface EmailBody {
  ContentType: string;
  Content: string;
}

// Contact person roles labels
export const ContactPersonRolesEnumLabel: {
  [key in ContactPersonRolesEnum]: string;
} = {
  [ContactPersonRolesEnum.CEO]: "VD",
  [ContactPersonRolesEnum.PurchaseManager]: "Inköpsansvarig",
  [ContactPersonRolesEnum.HeadFinance]: "Ekonomichef",
  [ContactPersonRolesEnum.Finance]: "Ekonomi",
  [ContactPersonRolesEnum.Owner]: "Ägare",
  [ContactPersonRolesEnum.Facility]: "Fastighet & underhåll",
  [ContactPersonRolesEnum.Marketing]: "Marknad/Sälj",
  [ContactPersonRolesEnum.Chairman]: "Ordförande",
  [ContactPersonRolesEnum.Environment]: "Miljö & hållbarhet",
};